/** Room left around cards scrolled into view. */
const MARGIN = 12;

/**
 * Where to scroll a sideways-scrolling row so a run of its items shows: all of them when they fit, else from the
 * first one. Positions are along the row's content, from its start.
 *
 * @param {{ scrollLeft: number, width: number }} view the row's scroll position and visible width
 * @param {{ left: number, right: number }[]} items the items to show
 * @returns {number} the scrollLeft to go to
 */
export function scrollToShow(view, items) {
  if (!items.length) {
    return view.scrollLeft;
  }
  const left = Math.min(...items.map(item => item.left)) - MARGIN;
  const right = Math.max(...items.map(item => item.right)) + MARGIN;
  if (right - left > view.width || left < view.scrollLeft) {
    return Math.max(0, left);
  }
  if (right > view.scrollLeft + view.width) {
    return right - view.width;
  }
  return view.scrollLeft;
}
